/* istanbul ignore file */

import PropTypes from 'prop-types';

import { getCookiesNotContainingKey } from '../../shared/utils/utils';

export const settingsType = {
  essential: 'essential', // these cookies cannot be removed
  marketing: 'marketing',
};

export const cookieTypes = Object.keys(settingsType).filter(
  (setting) => setting !== settingsType.essential
);

export const defaultCookieConsentState = () =>
  cookieTypes.reduce((obj, key) => Object.assign(obj, { [key]: false }), {});

const cookiePropTypes = cookieTypes.reduce(
  (obj, key) => Object.assign(obj, { [key]: PropTypes.bool.isRequired }),
  {}
);

export const CookieConsentShape = PropTypes.shape(cookiePropTypes);

const removeCookies = (cookieObjectArray) => {
  cookieObjectArray.map((cookieObject) => {
    const key = Object.keys(cookieObject)[0];

    window.document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;'`;
    return true;
  });
};

const removeAllNonHeyCarCookies = () => {
  // clear all cookies except for ours
  const removableCookies = getCookiesNotContainingKey(
    document.cookie,
    'persist',
    false
  );

  removeCookies(removableCookies);
};

const updateCallback = {
  marketing: {
    on() {
      if (typeof window.loadSegment === 'function' && !window.segmentLoaded) {
        window.loadSegment();
        window.segmentLoaded = true;
      }
    },
    off() {
      removeAllNonHeyCarCookies();
    },
  },
};

export const handleCookiesForCookieState = (cookieSettings) => {
  for (const cookieType in cookieSettings) {
    if (Object.hasOwnProperty.call(updateCallback, cookieType)) {
      if (cookieSettings[cookieType]) {
        updateCallback[cookieType].on();
      } else {
        updateCallback[cookieType].off();
      }
    }
  }
};
